<template>
    <div class="text-xs w-max pb-4 float-right">
        <span v-show="!(offset === 1)">
            <span @click="firstPage" class="cursor-pointer text-blue-700 hover:text-black">First</span> | 
            <span @click="previousPage" class="cursor-pointer text-blue-700 hover:text-black">Previous</span> | 
        </span>
        <span v-if="(offset + (PAGE_SIZE-1)) > totalRecordCount">Record {{offset}} - {{totalRecordCount}} of {{totalRecordCount}}</span>
        <span v-else>Record {{offset}} - {{offset+(PAGE_SIZE-1)}} of {{totalRecordCount}}</span>
        <span v-show="(offset+PAGE_SIZE-1) < totalRecordCount">
                | <span @click="nextPage" class="cursor-pointer text-blue-700 hover:text-black">Next</span> | 
            <span @click="lastPage" class="cursor-pointer text-blue-700 hover:text-black">Last</span>
        </span>   
    </div>

    <table style="cellpadding: 1px">
        <thead>
            <tr style="background-color: RGB(51, 102, 153)">
                <td @click="getOrders(offset, 'LL_Logout_Date', false)" class="label cursor-pointer text-xs w-28">Logout Date</td>
                <td class="label text-xs whitespace-nowrap">Cert</td>
                <td class="label text-xs whitespace-nowrap">Map</td>
                <td class="label text-xs whitespace-nowrap">Kit</td>
                <td @click="getOrders(offset, 'Prop_Applicant_Last', false)" class="label cursor-pointer text-xs whitespace-nowrap">Name</td>
                <td @click="getOrders(offset, 'status', false)" class="label cursor-pointer text-xs w-24">Status Info</td>
                <td @click="getOrders(offset, 'Requestor', false)" class="label cursor-pointer text-xs w-24">Requestor</td>
                <td @click="getOrders(offset, 'OLyesORno', false)" class="label cursor-pointer text-xs w-24">Insurance Required</td>
                <td @click="getOrders(offset, 'FCI_Zone', false)" class="label cursor-pointer text-xs">Flood Zone</td>
                <td class="label cursor-pointer text-xs"><a @click="getOrders(offset, 'Prop_Address', false)">Address</a><br><a @click="getOrders(offset, 'Prop_City', false)">City, </a><a @click="getOrders(offset, 'Prop_State', false)">State, </a><a @click="getOrders(offset, 'Prop_Zip', false)">Zip</a></td>
                <td @click="getOrders(offset, 'FCI#', false)" class="label cursor-pointer text-xs whitespace-nowrap">FCI #</td>
                <td @click="getOrders(offset, 'Loan_ID', false)" class="label cursor-pointer text-xs">Loan ID</td>
                <td @click="getOrders(offset, 'LL_Login_Date', false)" class="label cursor-pointer text-xs w-24">Login Date</td>
            </tr>
        </thead>
        <tbody class="border-2">
            <tr v-for="order in recentOrders" :key="order" style='border: solid RGB(210, 210, 210) 1px;'>
                <td v-for="(item, index) in order" :key="index" class="recentOrders text-xs" style="border-right: 1px; border-left: 1px" v-html="item">
                </td>
            </tr>
        </tbody>
      <tr><td class="nav" colspan="100%"></td></tr>
    </table>
    <div class="text-xs w-max float-right">
        <span v-show="!(offset === 1)">
            <span @click="firstPage" class="cursor-pointer text-blue-700 hover:text-black">First</span> | 
            <span @click="previousPage" class="cursor-pointer text-blue-700 hover:text-black">Previous</span> | 
        </span>
        <span v-if="(offset + (PAGE_SIZE-1)) > totalRecordCount">Record {{offset}} - {{totalRecordCount}} of {{totalRecordCount}}</span>
        <span v-else>Record {{offset}} - {{offset+(PAGE_SIZE-1)}} of {{totalRecordCount}}</span>
        <span v-show="(offset+PAGE_SIZE-1) < totalRecordCount">
                | <span @click="nextPage" class="cursor-pointer text-blue-700 hover:text-black">Next</span> | 
            <span @click="lastPage" class="cursor-pointer text-blue-700 hover:text-black">Last</span>
        </span>   
    </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
import sharedAPI from '@/api/SharedAPI.js'

export default defineComponent({
    props: [
        'query',
    ],
    setup(props, args) {
        const offset = ref(1)
        const currentSortField = ref("")
        const sortDirection = ref("descend")
        const PAGE_SIZE = 20
        const query = ref(null)

        const responseData = ref([]);
        const recentOrders = ref([]);
        const totalRecordCount = ref();


        //Changes offset when next page is clicked
        function nextPage(){
            offset.value = offset.value + PAGE_SIZE
            getOrders(offset.value, currentSortField.value, true)
        }
        function previousPage(){
            offset.value = offset.value - PAGE_SIZE
            getOrders(offset.value, currentSortField.value, true)
        }
        function firstPage(){
            offset.value = 1
            getOrders(offset.value, currentSortField.value, true)
        }
        function lastPage(){
            offset.value = totalRecordCount.value - (totalRecordCount.value % PAGE_SIZE) + 1 
            getOrders(offset.value, currentSortField.value, true)
        }

        async function getOrders(off, sortField, pagination){
            //This cant run when moving between pages.
            if ((sortField === currentSortField.value) && !pagination){
                sortDirection.value = sortDirection.value === "descend" ? "ascend" : "descend"
            }else if(!pagination){
                sortDirection.value = "descend"
                currentSortField.value = sortField
            }
            const data = {
                query: query.value,
                sort: [
                {
                    "fieldName": sortField,
                    "sortOrder": sortDirection.value
                }
                ],
                "limit": PAGE_SIZE,
                "offset": off,
            };

            const layout = "Web%20-%20FCI_Database";
            responseData.value = (await sharedAPI.find(data, layout));

            //If request returns any data
            if(responseData.value.data.response.data){
                totalRecordCount.value = responseData.value.data.response.dataInfo.foundCount;
                responseData.value = responseData.value.data.response.data;
            }else{
                const { emit } = args
                emit('no-results')
                return
            }

            //Map needed fields to new array for displaying
            recentOrders.value = responseData.value.map(order => {
                const logoutDate = order.fieldData['LL_Logout_Date']
                var cert = order.fieldData['TAGField']
                if (cert == 1){
                    cert = "<a href='https://www.floodplain.com/fcipdf/FLOODCERT"+order.fieldData['FCI#']+".pdf' target='_blank'><img src='/online/pdfImage.jpeg' height='25' width='25'></img></a>";
                }
                var map = order.fieldData['mapAvailable']
                if (map == 1){
                    map = "<a href='https://www.floodplain.com/fcimap/map"+order.fieldData['FCI#']+".pdf' target='_blank'><img src='/online/pdfImage.jpeg' height='25' width='25'></img></a>";
                }
                var kit = order.fieldData['zoneAAvailable']
                if (kit == 1){
                    kit = "<a href='https://www.floodplain.com/fcikit/KIT"+order.fieldData['FCI#']+".pdf' target='_blank'><img src='/online/pdfImage.jpeg' height='25' width='25'></img></a>";
                }
                const name = order.fieldData['Prop_Applicant_Last'] + ', ' + order.fieldData['Prop_Applicant_First'];
                const statusInfo = order.fieldData['status'] 
                const requestor = order.fieldData['Requestor']
                const insurance = order.fieldData['OLyesORno']
                const floodZone = order.fieldData['FCI_Zone']
                const address = order.fieldData['Prop_Address'] + '<br/>' +  order.fieldData['Prop_City'] + ', ' + order.fieldData['Prop_State'] + ', ' + order.fieldData['Prop_Zip'];
                const fciNum = order.fieldData['FCI#'] 
                const loanID = order.fieldData['Loan_ID']
                const loginDate = order.fieldData['LL_Login_Date']

                return [
                    logoutDate,
                    cert,
                    map,
                    kit,
                    name,
                    statusInfo,
                    requestor,
                    insurance,
                    floodZone,
                    address,
                    fciNum,
                    loanID,
                    loginDate,
                ]
            })
        }

        (async () => {
            query.value = props.query
            getOrders(1, "TimeStampLogin", false)
        })()

        return {
            offset,
            PAGE_SIZE,
            recentOrders,
            totalRecordCount,

            getOrders,
            nextPage,
            previousPage,
            lastPage,
            firstPage,
        }
    },
})
</script>

<style scoped>
    tbody tr:nth-child(odd){
        background-color: RGB(230, 230, 230);
    }
</style>
